<template>
  <FormModal :title="$t('field.application-type')">
    <template #body>
      <ServiceFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import ServiceFormStep from '~/components/form/steps/service/ServiceFormStep'

export default {
  components: {
    ServiceFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Type aanvraag',
      headDescription:
        'Geef aan naar wat voor type batterij installatie je op zoek bent.',
      path: '/offertes-aanvragen/type-aanvraag',
      checkoutStep: 1,
      progressValue: 25,
    }
  },
}
</script>
